// Copyright (c) 2016 Deere & Company

import {
    sharedToggleDealerAccountFacetItems,
    sharedUpdateDealerAccountFacetInput,
    sharedUpdateDealerAccountFacetItem
} from '../../../shared/reducers/facets';
import Facets from '../state/facets';
import actions from '../../actions-list';
import {getDefaultState} from '../state';
import {updateList} from '../../../shared/services/list-selections';

const togglePartRequestsSearchFacetsDealers = (state, action) =>
    Facets.update(state, {
        dealerAccountsFacet: {
            $set: sharedToggleDealerAccountFacetItems(state.dealerAccountsFacet, action)
        }
    });

const updatePartRequestsSearchFacets = (state, action) =>
    Facets.update(state, {
        dealerAccountsFacet: {
            allowedDealers: {
                $set: action.dealers
            },
            displayedDealers: {
                $set: action.dealers
            },
            searchInput: {
                $set: ''
            },
            selectedDealers: {
                $set: action.dealers
            }
        },
        isInitialLoad: {
            $set: action.isInitialLoad
        },
        requestTypes: {
            allowedTypes: {
                $set: action.allowedRequestTypes
            },
            selectedTypes: {
                $set: action.allowedRequestTypes
            }
        },
        statusFacet: {
            allowedStatuses: {
                $set: action.statuses
            },
            selectedStatuses: {
                $set: action.statuses
            }
        }
    });

const updateAllowedPartRequestTypes = (state, action) =>
    Facets.update(state, {
        requestTypes: {
            allowedTypes: {
                $set: action.allowedTypes
            }
        }
    });

const updatePartRequestsSearchFacetsDateRange = (state, action) =>
    Facets.update(state, {
        requestDateFacet: {
            dateRange: {
                $set: action.dateRange
            }
        }
    });

const updatePartRequestsSearchFacetsDealer = (state, action) =>
    Facets.update(state, {
        dealerAccountsFacet: {
            $set: sharedUpdateDealerAccountFacetItem(state.dealerAccountsFacet, action)
        }
    });

const updateDealerAccountFacetInput = (state, action) =>
    Facets.update(state, {
        dealerAccountsFacet: {
            $set: sharedUpdateDealerAccountFacetInput(state.dealerAccountsFacet, action)
        }
    });

const updateIsInitialLoad = state =>
    Facets.update(state, {
        dealerAccountsFacet: {
            isInitialLoad: {
                $set: false
            }
        }
    });

const updateSelectedPartRequestType = (state, action) =>
    Facets.update(state, {
        requestTypes: {
            selectedTypes: {
                $set: updateList(
                    action.requestType,
                    action.isSelected,
                    'key',
                    state.requestTypes.selectedTypes
                )
            }
        }
    });

const updateSelectedPartRequestTypes = (state, action) =>
    Facets.update(state, {
        requestTypes: {
            selectedTypes: {
                $set: action.requestTypes
            }
        }
    });

const updatePartRequestsSearchFacetsStatus = (state, action) =>
    Facets.update(state, {
        statusFacet: {
            selectedStatuses: {
                $set: updateList(
                    action.status,
                    action.isSelected,
                    'key',
                    state.statusFacet.selectedStatuses
                )
            }
        }
    });

const updatePartRequestsSearchFacetsStatuses = (state, action) =>
    Facets.update(state, {
        statusFacet: {
            selectedStatuses: {
                $set: action.statuses
            }
        }
    });

const actionTypes = {
    [actions.TOGGLE_PART_REQUESTS_SEARCH_FACETS_DEALERS]: togglePartRequestsSearchFacetsDealers,
    [actions.UPDATE_PART_REQUESTS_SEARCH_FACETS]: updatePartRequestsSearchFacets,
    [actions.UPDATE_PART_REQUESTS_SEARCH_FACETS_ALLOWED_REQUEST_TYPES]: updateAllowedPartRequestTypes,
    [actions.UPDATE_PART_REQUESTS_SEARCH_FACETS_DATE_RANGE]: updatePartRequestsSearchFacetsDateRange,
    [actions.UPDATE_PART_REQUESTS_SEARCH_FACETS_DEALER]: updatePartRequestsSearchFacetsDealer,
    [actions.UPDATE_PART_REQUESTS_SEARCH_FACETS_DEALER_FACET_INPUT]: updateDealerAccountFacetInput,
    [actions.UPDATE_PART_REQUESTS_SEARCH_FACETS_IS_INITIAL_LOAD]: updateIsInitialLoad,
    [actions.UPDATE_PART_REQUESTS_SEARCH_FACETS_SELECTED_REQUEST_TYPE]: updateSelectedPartRequestType,
    [actions.UPDATE_PART_REQUESTS_SEARCH_FACETS_SELECTED_REQUEST_TYPES]: updateSelectedPartRequestTypes,
    [actions.UPDATE_PART_REQUESTS_SEARCH_FACETS_STATUS]: updatePartRequestsSearchFacetsStatus,
    [actions.UPDATE_PART_REQUESTS_SEARCH_FACETS_STATUSES]: updatePartRequestsSearchFacetsStatuses
};

export default (state = getDefaultState().facets, action) => {

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/part-requests/search/reducers/facets.js